import {
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
  makeStyles,
} from '@material-ui/core'
import MoveIcon from 'assets/images/move@1x.svg'
import React, { useEffect, useState } from 'react'
import { Translate } from 'react-localize-redux'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { withRouter } from 'react-router-dom/cjs/react-router-dom'
import { players as playersModule } from '../../../../redux/modules'
import DeactivatePlayerDialog from './DeactivatePlayerDialog'
import TransferDestinationDialog from './TransferDestinationDialog'

const useStyles = makeStyles({
  menuRoot: {
    '& .MuiPopover-paper': {
      boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px',
    },
  },
})

const MovePlayer = ({
  playerUuid,
  playerStatus,
  deactivatePlayer,
  transferPlayer,
  withTransfer,
  seasons,
  match: {
    params: { seasonId },
  },
}) => {
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = useState(null)
  const [deactivate, setDeactivate] = useState(false)
  const [seasonUuid, setSeasonUuid] = useState(null)
  const [deactivateOpen, setDeactivateOpen] = useState(false)
  const [transferDestinationOpen, setTransferDestinationOpen] = useState(false)

  const deactivateEnabled = ['ACTIVE', 'TRANSFERRED'].includes(playerStatus)
  const transferEnabled = ['ACTIVE', 'TRANSFERRED', 'DEACTIVATED'].includes(
    playerStatus
  )

  const handleMoveOptionsOpen = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleMoveOptionsClose = () => {
    setAnchorEl(null)
  }

  const handleDeactivateClick = () => {
    setAnchorEl(null)
    setDeactivateOpen(true)
  }

  const handleDeactivateClose = () => {
    setDeactivateOpen(false)
  }

  const handleDeactivateSubmit = () => {
    setDeactivateOpen(false)
    deactivatePlayer(playerUuid)
  }

  const handleTransferDestinationOpen = () => {
    setAnchorEl(null)
    setTransferDestinationOpen(true)
  }

  const handleTransferDestinationClose = () => {
    setTransferDestinationOpen(false)
  }

  const handleTransferDestinationSubmit = (teamUuid) => {
     setTransferDestinationOpen(false)
    const data = {
      destination_team_uuid: teamUuid,
      deactivate: deactivate ? 1 : 0,
      season_uuid: seasonUuid,
    }
    transferPlayer(playerUuid, data)
  }

  // #remove Once season uuid can be accessed from url we dont need to find season like this
  useEffect(() => {
    if (seasons.length > 0) {
      const season = seasons.find((s) => s.id === +seasonId)
      setSeasonUuid(season.uuid)
    }
  }, [seasons])

  return (
    <>
      <Tooltip title={<Translate id="button.transfer" />} placement="top" arrow>
        <IconButton onClick={handleMoveOptionsOpen}>
          <img src={MoveIcon} alt="" />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        className={classes.menuRoot}
        open={!!anchorEl}
        onClose={handleMoveOptionsClose}
      >
        <MenuItem onClick={handleDeactivateClick} disabled={!deactivateEnabled}>
          <Translate id="movePlayers.archive-player" />
        </MenuItem>
        {withTransfer && (
          <MenuItem
            onClick={handleTransferDestinationOpen}
            disabled={!transferEnabled}
          >
            <Translate id="movePlayers.transfer-player" />
          </MenuItem>
        )}
      </Menu>

      {deactivateOpen && (
        <DeactivatePlayerDialog
          open={deactivateOpen}
          onClose={handleDeactivateClose}
          onSubmit={handleDeactivateSubmit}
        />
      )}
      {transferDestinationOpen && (
        <TransferDestinationDialog
          playerUuid={playerUuid}
          isChecked={deactivate}
          setChecked={setDeactivate}
          open={transferDestinationOpen}
          onClose={handleTransferDestinationClose}
          onSubmit={handleTransferDestinationSubmit}
        />
      )}
    </>
  )
}

MovePlayer.propTypes = {
  playerUuid: PropTypes.string.isRequired,
  playerStatus: PropTypes.string.isRequired,
  deactivatePlayer: PropTypes.func.isRequired,
  withTransfer: PropTypes.bool.isRequired,
  transferPlayer: PropTypes.func.isRequired,
  seasons: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      uuid: PropTypes.string.isRequired,
    })
  ).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      seasonId: PropTypes.string.isRequired,
    }),
  }).isRequired,
}

export default compose(
  withRouter,
  connect(
    ({ players, seasons: { items } }, { playerUuid }) => ({
      playerStatus: players.items.findByUuid(playerUuid)?.status,
      seasons: items,
    }),
    {
      deactivatePlayer: playersModule.deactivatePlayer,
      transferPlayer: playersModule.transferPlayer,
    }
  )
)(MovePlayer)
